<template>
  <div v-if="participants !='' || conParticipants !=''" class="participants">
    <div class="center info rounded-pill py-2 mx-14" style="color:white;">
      現在の参加人数
    </div>
    <div v-if="participants !='' " class="center text-h6 mb-2">
      {{participants}} 名
    </div>
    <div v-if="conParticipants !='' " class="center text-h6 mb-2">
      継続版: {{conParticipants}} 名
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'Participants',
  props: ['participants', 'conParticipants']
})
</script>
<style scoped lang="scss">
.participants {
  .center {
    margin: 5px auto;
    text-align: center;
  }
}
</style>
